import { buildEmployerPersonMatchPath, getHrefWithThreadPreservation } from '@yeshuman/sdk'
import type { PersonMatchDetailTab } from '@yeshuman/sdk'
import type { NavigateFunction } from 'react-router-dom'
import {
  buildJobWorkspacePersonBackPath,
  type JobWorkspacePersonLocationState,
  type NavigateToJobWorkspacePersonOptions,
} from './job-workspace-person-paths'

export function buildJobWorkspacePersonNavigationState(
  jobId: string,
  label: string,
  options?: NavigateToJobWorkspacePersonOptions,
): JobWorkspacePersonLocationState {
  const origin = options?.origin ?? 'analysis'
  return {
    label,
    origin,
    backPath: buildJobWorkspacePersonBackPath(jobId, origin),
  }
}

export function navigateToJobWorkspacePerson(
  navigate: NavigateFunction,
  jobId: string,
  profileId: string,
  label: string,
  options?: NavigateToJobWorkspacePersonOptions,
) {
  const evaluationId = options?.evaluationId ?? undefined
  const tab: PersonMatchDetailTab | null =
    options?.tab ??
    (evaluationId ? 'analysis' : null)
  const path = buildEmployerPersonMatchPath(jobId, profileId, {
    evaluationId,
    tab,
  })
  navigate(getHrefWithThreadPreservation(path), {
    state: buildJobWorkspacePersonNavigationState(jobId, label, options),
  })
}
